const PREVIEW_TOKEN_KEY = "preview_token";
const PREVIEW_BLOCKED_KEY = "preview_blocked_message";

export const getPreviewTokenFromPath = (pathname = "") => {
  try {
    const match = String(pathname || "").match(/^\/preview\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : "";
  } catch (_) {
    return "";
  }
};

export const getPreviewTokenFromSearch = (search = "") => {
  try {
    const sp = new URLSearchParams(search || "");
    return sp.get(PREVIEW_TOKEN_KEY) || "";
  } catch (_) {
    return "";
  }
};

export const getStoredPreviewToken = () => {
  if (typeof window === "undefined") return "";
  try {
    return sessionStorage.getItem(PREVIEW_TOKEN_KEY) || "";
  } catch (_) {
    return "";
  }
};

export const storePreviewToken = (token) => {
  if (!token || typeof window === "undefined") return;
  try {
    sessionStorage.setItem(PREVIEW_TOKEN_KEY, token);
  } catch (_) {}
};

export const getPreviewBlockedMessage = () => {
  if (typeof window === "undefined") return "";
  try {
    return sessionStorage.getItem(PREVIEW_BLOCKED_KEY) || "";
  } catch (_) {
    return "";
  }
};

export const setPreviewBlockedMessage = (message) => {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(PREVIEW_BLOCKED_KEY, message || "");
  } catch (_) {}
  try {
    window.dispatchEvent(new CustomEvent("preview-blocked", { detail: message || "" }));
  } catch (_) {}
};

export const clearPreviewBlockedMessage = () => {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(PREVIEW_BLOCKED_KEY);
  } catch (_) {}
  try {
    window.dispatchEvent(new CustomEvent("preview-blocked", { detail: "" }));
  } catch (_) {}
};

export const withPreviewToken = (search = "", token) => {
  if (!token) return search || "";
  try {
    const sp = new URLSearchParams(search || "");
    sp.set(PREVIEW_TOKEN_KEY, token);
    const next = sp.toString();
    return next ? `?${next}` : "";
  } catch (_) {
    const trimmed = String(search || "");
    const sep = trimmed.includes("?") ? "&" : "?";
    return `${trimmed}${sep}${PREVIEW_TOKEN_KEY}=${encodeURIComponent(token)}`;
  }
};

export const isPreviewPath = (pathname = "") => /^\/preview\/[^/?#]+/i.test(String(pathname || ""));
